export default function Market() {
  const targetCustomers = [
    {
      title: '장거리 세컨드 하우스 소유자',
      subtitle: '수도권 거주 5060 세대',
      description: '"일하러 가시나요, 쉬러 가시나요?" — 휴식권 보장 강조',
      icon: 'ri-home-smile-line',
      service: '전원주택 관리'
    },
    {
      title: '타지 거주 출향인',
      subtitle: '바쁜 직장인',
      description: '"죄송한 마음을 정성으로 대신합니다" — 효의 대행 및 신뢰 강조',
      icon: 'ri-user-heart-line',
      service: '산소 관리'
    },
    {
      title: '고령의 귀촌자',
      subtitle: '진주 지역 거주',
      description: '"우리 집 전담 주치의" — 육체적 한계 극복 및 기술 지원',
      icon: 'ri-heart-pulse-line',
      service: '전원주택 + 산소 복합'
    }
  ];

  return (
    <section id="market" className="relative py-16 sm:py-28 px-4 sm:px-6 overflow-hidden" style={{background: 'linear-gradient(150deg, #0d1f3c 0%, #111e3a 50%, #152a52 100%)'}}>
      <div className="absolute inset-0 opacity-[0.035]" style={{backgroundImage: 'linear-gradient(130deg, transparent 42%, #c9a227 43%, #c9a227 43.4%, transparent 44%), linear-gradient(80deg, transparent 58%, #c9a227 59%, #c9a227 59.3%, transparent 60%)', backgroundSize: '350px 350px'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Title */}
        <div className="text-center mb-12 sm:mb-20">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mb-4 sm:mb-5 leading-[1.2] tracking-tight">
            진주 지역 시장 환경
          </h2>
          <p className="text-base sm:text-xl text-white/70 leading-relaxed">
            혁신도시 연계 수요와 유교적 전통이 만나는 프리미엄 시장
          </p>
        </div>

        {/* Market Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-8 mb-8 sm:mb-24">
          {[
            { icon: 'ri-building-line', value: '혁신도시', desc: '금산면·문산읍 일대 고급 전원주택 밀집' },
            { icon: 'ri-user-star-line', value: '타임 푸어', desc: '고소득 전문직 종사자 타겟' },
            { icon: 'ri-ancient-gate-line', value: '유교 전통', desc: '출향인의 선산 관리 수요' },
          ].map((stat, i) => (
            <div key={i} className="rounded-xl sm:rounded-2xl px-4 py-3 sm:p-10 border border-[#c9a227]/20 transition-all duration-300 hover:shadow-lg hover:-translate-y-2 sm:flex-col sm:items-center sm:text-center" style={{background: 'linear-gradient(135deg, rgba(30,58,110,0.8), rgba(13,31,60,0.9))'}}>
              {/* Icon: PC only */}
              <div className="hidden sm:flex w-16 h-16 items-center justify-center mx-auto mb-5">
                <i className={`${stat.icon} text-5xl text-[#c9a227]`}></i>
              </div>
              <div className="text-lg sm:text-4xl font-bold text-[#c9a227] sm:mb-3 tracking-tight leading-tight">{stat.value}</div>
              <p className="text-xs sm:text-base text-white/70 leading-snug sm:leading-relaxed mt-0.5 sm:mt-0">{stat.desc}</p>
            </div>
          ))}
        </div>

        {/* Target Customers */}
        <div className="mb-8 sm:mb-24">
          <h3 className="text-2xl sm:text-4xl font-bold text-white mb-4 sm:mb-14 text-center tracking-tight">타겟 고객</h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-8">
            {targetCustomers.map((customer, index) => (
              <div key={index} className="rounded-xl sm:rounded-2xl overflow-hidden border border-[#c9a227]/20 transition-all duration-300 hover:shadow-lg hover:-translate-y-2 sm:flex-col" style={{background: 'linear-gradient(160deg, rgba(30,58,110,0.85), rgba(13,31,60,0.95))'}}>
                {/* Icon header: PC only */}
                <div className="hidden sm:flex w-full items-center justify-center p-8 border-b border-[#c9a227]/15">
                  <i className={`${customer.icon} text-7xl text-[#c9a227]`}></i>
                </div>
                {/* Content */}
                <div className="px-4 py-3 sm:p-7">
                  <div className="inline-block bg-[#c9a227]/15 px-2 py-0.5 sm:px-3 sm:py-1 rounded-full mb-1 sm:mb-4 border border-[#c9a227]/30">
                    <span className="text-xs font-semibold text-[#c9a227] tracking-wide">{customer.service}</span>
                  </div>
                  <h4 className="text-sm sm:text-xl font-bold text-white mb-0.5 sm:mb-2 tracking-tight leading-snug">{customer.title}</h4>
                  <p className="text-xs text-[#c9a227]/80 font-medium sm:mb-3 hidden sm:block">{customer.subtitle}</p>
                  <p className="text-xs text-white/65 leading-relaxed hidden sm:block">{customer.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Competitive Advantage */}
        <div className="rounded-2xl sm:rounded-3xl p-6 sm:p-14 shadow-xl border border-[#c9a227]/25" style={{background: 'linear-gradient(135deg, #1e3a6e, #0d1f3c)'}}>
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 sm:mb-14 text-center tracking-tight text-white">홈&amp;그레이브의 경쟁 우위</h3>

          {/* Comparison Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8 mb-6 sm:mb-14">
            {/* Left: Traditional */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-5 sm:p-9 border border-white/10">
              <div className="flex items-center gap-3 mb-4 sm:mb-7">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-red-500/20 rounded-full flex-shrink-0">
                  <i className="ri-close-line text-xl sm:text-2xl text-red-300"></i>
                </div>
                <h4 className="text-base sm:text-2xl font-bold tracking-tight text-white">기존 업체</h4>
              </div>
              <ul className="space-y-2.5 sm:space-y-5">
                {['현장 보고 가격 부르기', '작업 결과 확인 불가', '단순 인력 노동', '일회성 관리'].map((t, i) => (
                  <li key={i} className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-close-circle-line text-base sm:text-xl text-red-300 mt-0.5 flex-shrink-0"></i>
                    <span className="text-white/70 text-xs sm:text-base leading-relaxed">{t}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: Home&Grave */}
            <div className="rounded-2xl p-5 sm:p-9 shadow-lg border border-[#c9a227]/30" style={{background: 'linear-gradient(135deg, rgba(201,162,39,0.12), rgba(184,134,11,0.08))'}}>
              <div className="flex items-center gap-3 mb-4 sm:mb-7">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#c9a227]/20 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl sm:text-2xl text-[#c9a227]"></i>
                </div>
                <h4 className="text-base sm:text-2xl font-bold text-[#c9a227] tracking-tight">홈&amp;그레이브</h4>
              </div>
              <ul className="space-y-2.5 sm:space-y-5">
                {['21개 객관적 항목 기반 정찰제', '드론 촬영 디지털 리포트', '위성·GPS 데이터 분석', '사계절 연간 구독 관리'].map((t, i) => (
                  <li key={i} className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-circle-line text-base sm:text-xl text-[#c9a227] mt-0.5 flex-shrink-0"></i>
                    <span className="text-white font-medium text-xs sm:text-base leading-relaxed">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Key Features */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-7">
            {[
              { img: 'https://public.readdy.ai/ai/img_res/eb1eed36188f98986cdeeb7f14b17af8.jpg', icon: 'ri-file-list-3-line', title: '투명한 견적', desc: '21개 객관적 항목 기반 정찰제' },
              { img: 'https://readdy.ai/api/search-image?query=satellite%20imagery%20of%20Korean%20rural%20landscape%20from%20space%20showing%20terrain%20and%20vegetation%20analysis%2C%20high%20resolution%20earth%20observation%20data%20with%20grid%20overlay%2C%20scientific%20GIS%20mapping%20visualization%2C%20green%20hills%20and%20farmland%20aerial%20view%2C%20professional%20remote%20sensing%20technology&width=400&height=320&seq=market-feature-satellite-001&orientation=landscape', icon: 'ri-satellite-line', title: '위성 분석', desc: '10년치 위성 데이터 기반 지형 분석' },
              { img: 'https://readdy.ai/api/search-image?query=professional%20drone%20flying%20over%20Korean%20countryside%20capturing%20aerial%20footage%2C%20modern%20quadcopter%20drone%20in%20flight%20above%20green%20rural%20landscape%20with%20traditional%20grave%20site%20below%2C%20blue%20sky%20background%2C%20professional%20aerial%20photography%20equipment%2C%20high%20technology%20outdoor%20scene&width=400&height=320&seq=market-feature-drone-001&orientation=landscape', icon: 'ri-drone-line', title: '드론 보고', desc: '작업 전후 드론 촬영 디지털 리포트' },
              { img: 'https://readdy.ai/api/search-image?query=four%20seasons%20calendar%20subscription%20service%20concept%2C%20beautiful%20seasonal%20nature%20changes%20spring%20summer%20autumn%20winter%20collage%2C%20annual%20maintenance%20plan%20calendar%20on%20clean%20background%2C%20professional%20service%20schedule%20planner%2C%20soft%20warm%20tones%2C%20elegant%20lifestyle%20photography&width=400&height=320&seq=market-feature-annual-001&orientation=landscape', icon: 'ri-calendar-check-line', title: '연간 구독', desc: '사계절 통합 관리 패키지' },
            ].map((feat, i) => (
              <div key={i} className="text-center py-1 sm:py-0">
                {/* Image with icon overlay: PC only */}
                <div className="hidden sm:block w-full rounded-2xl overflow-hidden mb-4 relative" style={{ height: '110px' }}>
                  <img src={feat.img} alt={feat.title} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-[#0d1f3c]/50 flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center bg-[#c9a227]/20 rounded-full border border-[#c9a227]/40">
                      <i className={`${feat.icon} text-3xl text-[#c9a227]`}></i>
                    </div>
                  </div>
                </div>
                {/* Mobile: title only, no icon */}
                <h4 className="text-xs sm:text-xl font-bold sm:mb-2 tracking-tight text-white">{feat.title}</h4>
                <p className="text-white/65 text-xs leading-relaxed hidden sm:block">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
